export default "__VITE_ASSET__00b898a8__"